/**
 * Sanitizes a replicaId / voice_id so it contains only letters, numbers, hyphen (-), and underscore (_).
 * Removes BOM and any other disallowed characters. Returns empty string for null/undefined.
 */
export function sanitizeReplicaId(value: string | null | undefined): string {
  if (value == null || typeof value !== 'string') return '';
  return value.replace(/[^a-zA-Z0-9_-]/g, '').trim();
}

export function deepEqual(obj1, obj2) {
  // Base case: If both objects are identical, return true.
  if (obj1 === obj2) {
    return true;
  }
  // Check if both objects are objects and not null.
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false;
  }
  // Get the keys of both objects.
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);
  keys1 = keys1.filter( (key) => obj1[key] !== undefined );
  keys2 = keys2.filter( (key) => obj2[key] !== undefined );
  // Check if the number of keys is the same.
  if (keys1.length !== keys2.length) {
    return false;
  }
  // Iterate through the keys and compare their values recursively.
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  // If all checks pass, the objects are deep equal.
  return true;
}